import React, { useState, useRef, useEffect } from 'react';

const AutoResizeText = ({ text, width='100%' }) => {
  const containerRef = useRef(null);
  const [fontSize, setFontSize] = useState(16); // 初期フォントサイズを大きめに設定

  useEffect(() => {
    const resizeFont = () => {
      const container = containerRef.current;

      if (!container) return

      const containerWidth = container.offsetWidth;
      const containerHeight = container.offsetHeight;

      let currentFontSize = 16; // 調整用の初期フォントサイズ
      container.style.fontSize = `${currentFontSize}px`;

      // テキストが要素内に収まる場合はフォントサイズ調整不要
      if (container.scrollWidth <= containerWidth && container.scrollHeight <= containerHeight) {
        return
      }

      // フォントサイズを減少させて調整
      while ((container.scrollWidth > containerWidth || container.scrollHeight > containerHeight) && currentFontSize > 1) {
        currentFontSize -= 1;
        container.style.fontSize = `${currentFontSize}px`;
      }

      setFontSize(currentFontSize);
    };

    resizeFont();
  }, [])

  return (
    <div ref={containerRef} style={{ width: '100%', height: '100%' }}>
      {text}
    </div>
  );
};

export default AutoResizeText;
